import * as React from "react";
import TextFlagCreationDialog from "./TextFlagCreationDialog";
import {FlagDto} from "../../../services/Client";
import Button from "../../../components/Button";
import TextField from "../../../components/TextField";

interface ITextFlagActionsHeader {
    onExitDialog: (newFlag?: FlagDto) => void;
    onFilter: (event: React.FormEvent<{}>, newValue: string) => void;
    openDialog: () => void;
    onEdit: () => void;
    getFlags: () => void;
    canEdit: boolean;
    canCreate: boolean;
    editMode: boolean;
    showCreationDialog: boolean;
    filterValue?: string;
    t: reactI18Next.TranslationFunction;
}

export const TextFlagActionsHeader: React.SFC<ITextFlagActionsHeader> = (props: ITextFlagActionsHeader) => {

    return (
        <React.Fragment>
            {props.showCreationDialog &&
                <TextFlagCreationDialog
                    onExitDialog={props.onExitDialog}
                />
            }
            <div>
                {props.canCreate &&
                    <Button
                        label={props.t("TEXT_FLAG:ADD_FLAG")}
                        labelPosition="after"
                        icon="add"
                        onClick={props.openDialog}
                    />
                }
                {props.canEdit &&
                    <Button
                        icon={props.editMode ? "close" : "pencil"}
                        labelPosition={'after'}
                        label={props.t(props.editMode ? "GLOBAL:STOP_EDITING" : "GLOBAL:START_EDITING")}
                        onClick={props.onEdit}
                    />
                }
                <Button
                    label={props.t("GLOBAL:RELOAD")}
                    labelPosition="after"
                    icon="refresh"
                    onClick={props.getFlags}
                />
            </div>
            <TextField
                placeholder={props.t("TEXT_FLAG:FILTER_FLAGS")}
                value={props.filterValue}
                onChange={props.onFilter}
            />
        </React.Fragment>
    );
};

export default TextFlagActionsHeader;



// WEBPACK FOOTER //
// ./src/views/AdminView/FlagTab/TextFlagActionsHeader.tsx